import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { FileText, Download } from 'lucide-react';
export function WhatYouGet() {
  const printables = ['30‑Night Stabilization Ladder Tracker', 'Leak Type Identifier Sheet', 'Leak → Dry‑Mouth Map', 'Humidity/Rainout Tuning Card (7-night protocol)', 'Settings Questions Checklist (Provider handout)', '"Rip‑It‑Off" Retraining Log', 'DME/Doctor Call Script + Appointment One‑Pager'];
  return <section className="py-12 px-4 bg-navy-900 text-white" data-id="element-406">
      <div className="max-w-5xl mx-auto" data-id="element-407">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-408">
          <FadeIn data-id="element-409">
            <h2 className="text-3xl md:text-4xl font-bold mb-8" data-id="element-410">
              What You Get (Instant Download)
            </h2>
            <p className="text-xl text-blue-100 mb-8" data-id="element-411">
              CPAP Compliance Rescue (50–80 pages equivalent) plus 7 printables:
            </p>

            <ul className="space-y-4 mb-8" data-id="element-412">
              {printables.map((item, i) => <li key={i} className="flex items-start" data-id="element-413">
                  <FileText className="h-6 w-6 text-amber-500 mr-3 flex-shrink-0" data-id="element-414" />
                  <span className="text-lg text-gray-200" data-id="element-415">{item}</span>
                </li>)}
            </ul>

            <div className="inline-flex items-center text-teal-400 font-medium" data-id="element-416">
              <Download className="h-5 w-5 mr-2" data-id="element-417" />
              Delivered Immediately via Email
            </div>
          </FadeIn>

          <FadeIn delay={200} data-id="element-418">
            <div className="bg-white/5 p-4 rounded-2xl border border-white/10" data-id="element-419">
              <img src="https://cdn.magicpatterns.com/uploads/ikNs4K7zcgG2UnTB7zFUdY/heylloyd-image-1770960574266.png" alt="Digital Product Bundle" className="w-full h-auto rounded-lg shadow-2xl" data-id="element-420" />
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}